/* tslint:disable */
/* eslint-disable */

/**
 * A field group the FH picks a winning row for during a merge. Picks are group-atomic so paired columns (address parts, routing operator+address, company-form code/other) can never mix across rows.
 */
export enum MergePickGroup {
  Name = 'name',
  Address = 'address',
  EinvoiceRouting = 'einvoice_routing',
  CreditLimit = 'credit_limit',
  AaaRating = 'aaa_rating',
  CompanyForm = 'company_form',
  CompanySituation = 'company_situation',
  VatNumber = 'vat_number',
  Discount = 'discount'
}
